import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { SudoAiChatLauncherComponent } from 'bp/modules/ai-chat/components/sudo-ai-chat-launcher.component';
import { SudoAiChatLoader } from 'bp/modules/ai-chat/sudo-ai-chat.loader';
import { SUDO_AI_CHAT_ROUTE } from 'bp/modules/ai-chat/sudo-ai-chat.models';
import { filter } from 'rxjs';

/**
 * Entrada del Asesor IA en el layout (049, T095; HU6): el botón flotante y el panel lateral, solo si los roles del
 * token habilitan el chat interno (`SUDO_AI_CHAT_ROLES`) y `GetAvailability` responde `full`. Sin eso (o mientras se
 * consulta) no se muestra nada: ya no hay chat anterior. En la página `/ai-chat` el botón se oculta.
 */
@Component({
  selector: 'ai-chat-widget',
  template: `
    @if (sudoChat.canUseChat() && sudoChat.mode() === 'full') {
      <sudo-ai-chat-launcher [hidden]="isOnChatPage()" />
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'aiChatWidget',
  standalone: true,
  imports: [SudoAiChatLauncherComponent],
})
export class AiChatWidgetComponent {
  private readonly router = inject(Router);
  readonly sudoChat = inject(SudoAiChatLoader);
  readonly isOnChatPage = signal(this.router.url.startsWith(SUDO_AI_CHAT_ROUTE));

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(e => this.isOnChatPage.set(e.urlAfterRedirects.startsWith(SUDO_AI_CHAT_ROUTE)));
  }
}
